const debounce = (func : Function, wait : number = 10) => {
  let timeout;

  return (...args : any[]) => {
    if (timeout)
      clearTimeout(timeout);
    const context = this;

    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait);
  };
}

export default debounce;